var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#331F40","d":"M0 0h28v3H0z","key":0}),React.createElement("path",{"fill":"#5E3B73","d":"M4 7h20v3H4z","key":1}),React.createElement("path",{"fill":"#774695","d":"M8 14h12v3H8z","key":2})]));
}

Filter.defaultProps = {"width":"28","height":"17","viewBox":"0 0 28 17"};

module.exports = Filter;

Filter.default = Filter;
